// extracted by mini-css-extract-plugin
module.exports = {"downloadFileIcon":"JSBoothDetail_downloadFileIcon__3xh-M","filenameWrapper":"JSBoothDetail_filenameWrapper__3OdBi","jobTitleInput":"JSBoothDetail_jobTitleInput__3fTrV"};